// src/Components/Home/FlowSequence.jsx
import React, { useEffect, useRef, useState } from "react";
import "./FlowSequence.css";

export default function FlowSequence() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect(); // run once
        }
      },
      { threshold: 0.35 }
    );

    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={ref} className={`flowseq ${visible ? "is-visible" : ""}`}>
      <div className="flowseq-stage">
        {/* Desktop / default: straight line */}
        <div className="flowseq-desktop" aria-label="Flow: App to Food">
          <div className="flowseq-step s1">APP</div>
          <div className="flowseq-arrow a1" aria-hidden="true" />

          <div className="flowseq-step s2">INGREDIENTS</div>
          <div className="flowseq-arrow a2" aria-hidden="true" />

          <div className="flowseq-step s3 cook">
            <span>COOK WITH </span>
            <span>ROBOT</span>
          </div>
          <div className="flowseq-arrow a3" aria-hidden="true" />

          <div className="flowseq-step s4">FOOD!!</div>
        </div>

        {/* Mobile: box layout */}
        <div className="flowseq-mobile" aria-label="Flow: App to Food (box)">
          <div className="flowseq-step m1">APP</div>
          <div className="flowseq-arrow mA" aria-hidden="true" />

          <div className="flowseq-step m2">INGREDIENTS</div>
          <div className="flowseq-arrow mDown" aria-hidden="true" />

          <div className="flowseq-step m3">COOK WITH ROBOT</div>
          <div className="flowseq-arrow mLeft" aria-hidden="true" />

          <div className="flowseq-step m4">FOOD!!</div>
        </div>
      </div>
    </section>
  );
}